import { StatusCategoriaTorneio } from '../types/categoriaTorneio';

export interface CategoriaStatusDisplay {
  value: string;
  label: string;
  color: string;
  bg: string;
}

export function getCategoriaStatusDisplay(input: {
  status?: string | null;
  temPartidas?: boolean | null;
}): CategoriaStatusDisplay {
  const { status, temPartidas } = input;

  switch (status) {
    case StatusCategoriaTorneio.EM_ANDAMENTO:
      return {
        value: StatusCategoriaTorneio.EM_ANDAMENTO,
        label: 'Em andamento',
        color: '#0dcaf0',
        bg: 'rgba(13,202,240,0.2)',
      };
    case StatusCategoriaTorneio.ENCERRADA:
      return {
        value: StatusCategoriaTorneio.ENCERRADA,
        label: 'Concluída',
        color: '#198754',
        bg: 'rgba(25,135,84,0.2)',
      };
    case StatusCategoriaTorneio.INSCRICAO_ENCERRADA:
      if (temPartidas) {
        return {
          value: StatusCategoriaTorneio.INSCRICAO_ENCERRADA,
          label: 'Partidas criadas',
          color: '#6f42c1',
          bg: 'rgba(111,66,193,0.2)',
        };
      }
      return {
        value: StatusCategoriaTorneio.INSCRICAO_ENCERRADA,
        label: 'Inscrições encerradas',
        color: '#fd7e14',
        bg: 'rgba(253,126,20,0.2)',
      };
    case StatusCategoriaTorneio.INSCRICAO_ABERTA:
      return {
        value: StatusCategoriaTorneio.INSCRICAO_ABERTA,
        label: 'Inscrições abertas',
        color: '#0d6efd',
        bg: 'rgba(13,110,253,0.2)',
      };
    case StatusCategoriaTorneio.AGENDADA:
      return {
        value: StatusCategoriaTorneio.AGENDADA,
        label: 'Criada',
        color: '#6c757d',
        bg: 'rgba(108,117,125,0.2)',
      };
    default:
      return {
        value: status ?? '',
        label: status ?? '',
        color: '#6c757d',
        bg: 'rgba(108,117,125,0.2)',
      };
  }
}
